import { useBreakpoint } from './media-query.hook'

export const useIsMobile = () => useBreakpoint('xsDown')
